
















import Webview from '@/webview';
import { Prop, Component } from 'vue-property-decorator';

@Component
export default class BottomTab extends Webview {
  @Prop({
    type: String,
    default: 'unset'
  })
  leftWidth!: string;

  @Prop({
    type: String,
    default: '#fff'
  })
  background!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  border!: boolean;
}
